// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-64971e60] #pricing-table th {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
